













































































































































































































































































































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
//@ts-ignore
import TableWeightInput from '@/views/Viewpoint/Weighting/ViewpointFixedTableWeightGroup.vue';
import DotCounter from '@/components/weighting/DotCounter.vue';
import { getModule } from 'vuex-module-decorators';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Viewpoints from '@/store/modules/Viewpoints';
import Users from '@/store/modules/Users';
import TableSingleWeightInput from '@/views/Viewpoint/Weighting/ViewpointGrowingTableWeightGroup.vue';
import Modelling from '@/store/modules/Modelling';
import Weighting from '@/store/modules/Weighting';
import { FactorGroup } from '@/api/model/FactorResource';
import ViewpointFactorVisibilityButtonTrigger from '@/components/viewpoint-factor-visibility/ViewpointFactorVisibilityButtonTrigger.vue';
import ScoringKeyButtonTrigger from '@/components/scoring-key/ScoringKeyButtonTrigger.vue';
import FactorGroupScoringDefinition from '@/components/scoring-definition/FactorGroupScoringDefinition.vue';
import { ViewpointFactorResource } from '@/api/model/ViewpointFactorResource';
import { NotificationEventBus } from '@/EventBus';
import FactorScoringDefinitionButtonTrigger from '@/components/scoring-definition/FactorScoringDefinitionButtonTrigger.vue';
import WeightFactorImportanceChart from '@/views/Viewpoint/Weighting/WeightFactorImportanceChart.vue';
import WeightGroupedBarChart from '@/views/Viewpoint/Weighting/WeightGroupedBarChart.vue';
import Decisions from '@/store/modules/Decisions';

const workspaceOptionsModule = getModule(WorkspaceOptions);
const viewpointsModule = getModule(Viewpoints);
const usersModule = getModule(Users);
const modellingModule = getModule(Modelling);
const weightingModule = getModule(Weighting);
@Component({
    name: 'WeightingGroupComp',
    components: {
        ViewpointFactorVisibilityButtonTrigger,
        TableSingleWeightInput,
        DotCounter,
        TableWeightInput,
        ScoringKeyButtonTrigger,
        FactorGroupScoringDefinition,
        FactorScoringDefinitionButtonTrigger,
        WeightFactorImportanceChart,
        WeightGroupedBarChart
    },
})
export default class WeightingGroup extends Vue {
    @Prop()
    elements!: string[];

    @Prop()
    usedDots!: number;

    @Prop()
    totalDots!: number;

    @Prop({default:false, type:Boolean})
    appEmbed!: boolean;

    hovers = Array.apply(null, new Array(this.elements.length)).map((f) => false);

    // description
    get descriptionVisibility() {
        return workspaceOptionsModule.descriptionVisibility;
    }

    get singularFactorLabel() {
        return getModule(Decisions).singularFactorLabel;
    }

    get singularViewpointLabel() {
        return getModule(Decisions).singularViewpointLabel;
    }

    get currentUserId() {
        return usersModule.currentUserProfile.userId;
    }

    get expansionValues() {
        return workspaceOptionsModule.expansions;
    }

    get selectionPath() {
        return workspaceOptionsModule.selectionPath;
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints;
    }

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get viewpointFactors() {
        return viewpointsModule.viewpointFactorResources;
    }

    get viewpointsWeightingDotsMap() {
        return weightingModule.viewpointGroupDots;
    }

    get columnWidth() {
        return workspaceOptionsModule.choiceColumnWidth;
    }

    // description
    private getDescriptionVisibility() {
        return this.descriptionVisibility;
    }

    private getFactorResourceDotCount(viewpointId: string, factorResourceId: string) {
        let viewpointFactor = this.viewpointFactors[viewpointId][factorResourceId];
        if (viewpointFactor && viewpointFactor.numWeightingDots != null) {
            return viewpointFactor.numWeightingDots;
        }
        return this.factors[factorResourceId].numWeightingDots || 0;
    }
 
    private async changeParentsDots(
        viewpointId: string,
        factorResourceId: string,
        newValue: number
    ) {
        await weightingModule.updateViewpointWeightsWithoutSubmit({
            viewpointId: viewpointId,
            factors: { [factorResourceId]: newValue },
        });
        this.dotsChanged(viewpointId);
    }

    private async zeroOutGroup(viewpointId: string, factorGroup: FactorGroup) {
        let newFactorWeights = {};
        let numberOfDots = this.setGroupToValue(viewpointId, factorGroup, newFactorWeights, 0);
        await weightingModule.updateViewpointWeightsWithoutSubmit({
            viewpointId: viewpointId,
            factors: newFactorWeights,
        });
        this.dotsChanged(viewpointId);
    }

    get factorListTree(){
        return modellingModule.factorListTree
    }

    get isViewpointActive() {
        return (viewpointsModule.activeViewpointId != null)
    }

    get isFactorListActive() {
        return workspaceOptionsModule.activeFactorLists.length > 0
    }

     get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    get editWeights() {
        return workspaceOptionsModule.editWeights;
    }

    get editSumRule() {
        return workspaceOptionsModule.editSumRule;
    }

    get editScoringRule() {
        return workspaceOptionsModule.editScoringRule;
    }

     private isFactorVisible(resourceId: string) {
        if(this.showNonListFactors || !this.isFactorListActive) {
            return  true
        }
        else {
            if(this.isFactorListActive && this.factorListTree[resourceId] && !this.showNonListFactors) {
                    return true
            } else
                return false;
        }
    }

    private startingFactors(resourceId: string) {
        if(workspaceOptionsModule.trimTopGroups) {
            let topFactor = resourceId
            return this.getTopGroup(resourceId)
        
        } else {
            return this.factors[resourceId].childrenIds
        }
        
    }

    private getTopGroup(topId: string) {
        if(this.factors[topId].childrenIds.length != 1 ? true: 'groupTypeDefinition' in this.factors[this.factors[topId].childrenIds[0]] || this.factors[this.factors[topId].childrenIds[0]].type != 'FACTOR_GROUP') {
            return this.factors[topId].childrenIds
        }

        if(this.factors[topId].childrenIds.length === 1) {
            return this.getTopGroup(this.factors[topId].childrenIds[0])
        }
        
    }

    private setGroupToValue(
        viewpointId: string,
        factorGroup: FactorGroup,
        newFactorWeights: { [id: string]: number },
        value: number
    ): number {
        return (factorGroup.childrenIds || [])
            .map((child) => {
                if (this.factors[child].type === 'FACTOR') {
                    newFactorWeights[child] = value;
                    return 0;
                } else if (
                    (this.factors[child] as FactorGroup).groupTypeDefinition &&
                    (this.factors[child] as FactorGroup).groupTypeDefinition.type === 'TABLE_FIXED'
                ) {
                    let tableFactorGroup = this.factors[child] as FactorGroup;
                    let childDots = tableFactorGroup.childrenIds
                        .map((tr) =>
                            this.setGroupToValue(
                                viewpointId,
                                this.factors[tr] as FactorGroup,
                                newFactorWeights,
                                value
                            )
                        )
                        .filter((n) => n != null)
                        .reduce((a, b) => a + b, 0);
                    return childDots;
                } else {
                    return this.setGroupToValue(
                        viewpointId,
                        this.factors[child] as FactorGroup,
                        newFactorWeights,
                        value
                    );
                }
            })
            .filter((n) => n != null)
            .reduce((a, b) => a + b, 0);
    }

    private async distributeOneToAllInGroup(viewpointId: string, factorGroup: FactorGroup) {
        let newFactorWeights = {};
        let numberOfDots = this.setGroupToValue(viewpointId, factorGroup, newFactorWeights, 1);
        await weightingModule.updateViewpointWeightsWithoutSubmit({
            viewpointId: viewpointId,
            factors: newFactorWeights,
        });
        this.dotsChanged(viewpointId);
    }

    private selectBreadcrumbItem(id: string) {
        workspaceOptionsModule.selectBreadcrumbItem(id);
    }

    @Emit('dots-changed')
    private dotsChanged(viewpointId: string) {
        return viewpointId;
    }

    private factorGroupScoringDefinitionChange(factorGroupId: string, scoringDefinition: any, selectedViewpoint: string) {
        if (!selectedViewpoint) return;

        let viewpointFactor: ViewpointFactorResource;
        if (this.viewpointFactors && this.viewpointFactors[selectedViewpoint] && this.viewpointFactors[selectedViewpoint][factorGroupId]) {
            viewpointFactor = this.viewpointFactors[selectedViewpoint][factorGroupId];
            viewpointFactor.summaryScoringFunction = scoringDefinition.summaryScoringFunction;
            viewpointFactor.hideScores = scoringDefinition.hideScores;
            
        } else {
            viewpointFactor = {
                id: factorGroupId,
             //   scoringKeyDefinition: scoringDefinition,
                viewpointId: selectedViewpoint,
                summaryScoringFunction: scoringDefinition.summaryScoringFunction,
                hideScores: scoringDefinition.hideScores
            };
        }

        NotificationEventBus.emitProcessingMessage();
        viewpointsModule
            .putViewpointFactor(viewpointFactor)
            .then((result) => NotificationEventBus.emitSuccessMessage())
            .catch((err) => NotificationEventBus.emitFailedMessage(err));
    }

    private isEyeVisible(index: number, viewpointId: string, factorId: string){
        return this.hovers[index] || (this.viewpointFactors[viewpointId] && this.viewpointFactors[viewpointId][factorId] && this.viewpointFactors[viewpointId][factorId].visibilityDefinition)                       
    }

    private isKeyVisible(index: number, viewpointId: string, factorId: string){
        if (this.editScoringRule) {
            return this.hovers[index] || (this.viewpointFactors[viewpointId] && this.viewpointFactors[viewpointId][factorId] && (this.viewpointFactors[viewpointId][factorId].scoringDefinition || this.viewpointFactors[viewpointId][factorId].scoringKeyDefinition))                  
        }
        else {
            return false;
        }
    }

    private isSummaryVisible(index: number, viewpointId: string, factorId: string){
        if (this.editSumRule) {
            return this.hovers[index] || (this.viewpointFactors[viewpointId] && this.viewpointFactors[viewpointId][factorId] && this.viewpointFactors[viewpointId][factorId].summaryScoringFunction != 'WEIGHTED_SUM')                  
        }
        else {
            return false;
        }
    }

    private isChartVisible(index: number, viewpointId: string, factorId: string){
        return this.hovers[index];                 
    }
}
